import { EmojiPickerService } from '../../ng-services/emoji-picker.service';
// There's a weird bug, where non minified version of simpleMDE includes a v-scroll
// @ts-ignore
import SimpleMDE from 'simplemde/dist/simplemde.min';

const TOOLBAR_PRESETS = {
    chat: ['bold', 'italic', 'strikethrough', '|', 'quote', 'code', 'horizontal-rule', '_emoji'],
    post: [
        'bold',
        'italic',
        'strikethrough',
        '|',
        'unordered-list',
        'ordered-list',
        '|',
        'quote',
        'code',
        'horizontal-rule',
        '_emoji',
    ],
};

(function () {
    class SimplemdeComponent {
        static $inject = ['$element', '$timeout', 'EmojiPickerService'];

        placeholder!: string;
        value!: string;
        onChange?: (payload: { $value: string }) => any;
        onSubmit?: (payload: { $value: string }) => any;
        onKeydown?: (payload: { $event: KeyboardEvent }) => any;
        submitOnEnter: boolean = true;
        toolbarPreset: 'chat' | 'post' = 'chat';

        simplemde!: SimpleMDE;

        constructor(
            private $element: ng.IRootElementService,
            private $timeout: ng.ITimeoutService,
            private emojiPickerService: EmojiPickerService
        ) {}

        /**
         * monitor changed value and update simplemde state
         * @param changes
         */
        $onChanges(changes: ng.IOnChangesObject) {
            const currentValue = changes.value?.currentValue;
            const editorValue = this.simplemde?.value();

            // update editor value only if it is different from the change value
            // otherwise every change would result in editor updating, which would move the cursor to 0
            if (currentValue !== editorValue) {
                this.$timeout(() => {
                    this.simplemde?.value(changes.value.currentValue);
                    // The message value changes when we are starting an edit action.
                    // We want the cursor to be set at the end of the edited message.
                    // Moving it to a big line number should always* set it at the end.
                    this.simplemde?.codemirror.setCursor(9999);
                });
            }
        }

        $onInit() {
            const element = this.$element.find('textarea')[0];

            this.simplemde = new SimpleMDE({
                autoDownloadFontAwesome: false,
                element,
                placeholder: this.placeholder,
                toolbar: this._getToolbar(),
                spellChecker: false,
                status: false,
                initialValue: this.value,
            });

            // $timeout is used because simplemde events are not fired in angular digest cycle
            this.simplemde.codemirror.on('change', () =>
                this.$timeout(() => {
                    const value = this.simplemde.value();
                    this.onChange && this.onChange({ $value: value });
                })
            );

            this.simplemde.codemirror.on('keydown', (cm: any, event: any) =>
                this.$timeout(() => {
                    this.onKeydown && this.onKeydown({ $event: event });
                })
            );

            // we dont use drag-n-drop, so turn it off to avoid grabbing the event.
            // we implement drag-n-drop file upload higher in the component tree.
            this.simplemde.codemirror.setOption('dragDrop', false);

            // Sometimes we might want to submit with enter instead of creating a new line.
            if (this.submitOnEnter) {
                const onKeyEnter = () =>
                    this.$timeout(() => {
                        return this.onSubmit && this.onSubmit({ $value: this.simplemde.value() });
                    });

                const extraKeys = this.simplemde.codemirror.getOption('extraKeys');
                this.simplemde.codemirror.setOption('extraKeys', {
                    ...extraKeys,
                    Enter: onKeyEnter,
                });
            }
        }

        $onDestroy() {
            // destroy simplemde
            this.simplemde.toTextArea();
        }

        private _getToolbar(): any {
            const factories: { [k: string]: Function } = {
                _emoji: () => this.emojiPickerService.createToolbarIcon(this.$element),
            };

            const tools = TOOLBAR_PRESETS[this.toolbarPreset];
            return tools.map((t) => (factories[t] ? factories[t]() : t));
        }
    }

    angular.module('tradersyard').component('tySimplemde', {
        template: `<textarea></textarea>`,
        controller: SimplemdeComponent,
        bindings: {
            value: '<',
            placeholder: '@',
            onChange: '&',
            onKeydown: '&',
            // usually triggered by pressing Enter, but might change based on the key-map
            onSubmit: '&?',
            submitOnEnter: '<?',
            toolbarPreset: '@?',
        },
    });
})();
